const safetyQuestionsSample = [
  {
    name: "Any accidents on site today?",
    status: "",
    description: ""
  },
  {
    name: "Any schedule delay occurred?",
    status: "",
    description: ""
  },
  {
    name: "Did weather cause any delay?",
    status: "",
    description: ""
  },
  {
    name: "Any visitor on site?",
    status: "",
    description: ""
  },
  {
    name: "Any areas that can't be worked on?",
    status: "",
    description: ""
  },
  {
    name: "Any equipment rented on site?",
    status: "",
    description: ""
  },
  {
    name: "Consultant Visit",
    status: "",
    description: ""
  }
];

export { safetyQuestionsSample };
